import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { Subscription } from 'rxjs';
import { GroupDTO } from '../angular-assign-tool/angular-assign-tool.models';
import { AssignmentSelection } from 'src/AngularJS/Dashboard/dashboard-assignment.model';

@Component({
    selector: 'metric-definition-assignment',
    templateUrl: './metric-definition-assignment.component.html',
    styleUrls: ['./metric-definition-assignment.component.scss']
})
export class MetricDefinitionAssignmentComponent implements OnInit, OnChanges, OnDestroy {

    @Input()
    lst: GroupDTO[]; // List of selected GroupDTOs from the middle column of Assign Tool

    @Input()
    selectedGroupType: string = "";

    @Input()
        activeSelection: AssignmentSelection;

    // Same as selectedGroupType, but it doesn't go away when the modal is closed (if there are selected groups)
    // Displayed above the selected Groups
    currentGroupType: string = "";

    @Output()
    onRemove: EventEmitter<GroupDTO> = new EventEmitter<GroupDTO>();

    recGroups: GroupDTO[] = [];

    constructor() { }

    ngOnInit() {
        this.currentGroupType = this.selectedGroupType;
    }

    ngOnDestroy(): void {
    }

    ngOnChanges(changes: SimpleChanges) {
        for (const changedProperty in changes) {
            if (changedProperty == "lst" || changedProperty === "activeSelection") {
                this.listChanged();
            } else if (changedProperty == "selectedGroupType") {
                this.selectedGroupTypeChanged();
            }
        }
    }

    private listChanged() {
        this.recGroups = this.lst.filter(g => g.BaseGroupType === 1);
    }

    /**
     * Updates the variable currentGroupType, but only when the selectedGroupType is truthy.
     * This retains the previous selectedGroupType value when the modal is closed, since the selectedGroupType is unset.
     */
    private selectedGroupTypeChanged() {
        if (this.selectedGroupType)
            this.currentGroupType = this.selectedGroupType;
    }

    /**
     * Removes the assignment from the list, then emits the event so the Assign Tool can show the group again
     * @param groupDTO 
     */
    removeGroup(groupDTO: GroupDTO) {
        let index = this.lst.indexOf(groupDTO);
        if (index >= 0) {
            this.lst.splice(index, 1);
            this.onRemove?.emit(groupDTO);
        }
    }

    trackByGroupID(index: number, item: GroupDTO) {
        return item.GroupID;
    }
}
